export let baseUrl;

if (process.env.NODE_ENV == "development") {
  baseUrl = `https://dev-research.usx.co.nz/api`;
} else if (process.env.REACT_APP_BACKEND) {
  baseUrl = process.env.REACT_APP_BACKEND;
} else {
  baseUrl = `https://dev-research.usx.co.nz/api`;
}
